// Where a job on the production plan stands. Mirrors TMSWeb.Common.Constants.ProductionPlanStates -
// the API sends these on every planned job, so the two must stay in step.
export enum ProductionPlanStates {
  onTime = 'OnTime',
  late = 'Late',
  weavingNow = 'WeavingNow',
  problem = 'Problem',
}
